import { OverlayTrigger, Tooltip } from 'react-bootstrap';
import clsx from 'clsx';
import { useTranslation } from 'react-i18next';

import StatusIcon from './StatusIcon.jsx';
import { RIVER_STATE_ANALYSIS_HOURS } from '../helpers/SiteData.js';

import styles from './CardStatus.module.css';

function CardStatus({status, className}) {
  const {t} = useTranslation();

  return (
    <div className={className}>
      <OverlayTrigger
        overlay={(props) =>
          <Tooltip
            id="card-status-tooltip"
            {...props}
          >
            {t(`status.${status}.description`, {count: RIVER_STATE_ANALYSIS_HOURS})}
          </Tooltip>
        }
      >
        <div className={clsx(styles.CardStatus, styles[`CardStatus--${status}`])}>
          <StatusIcon status={status} className={styles.CardStatusIcon} />
          <div className={styles.CardStatusLabel}>
            {t(`status.${status}.label`)}
          </div>
        </div>
      </OverlayTrigger>
    </div>
  );
}

export default CardStatus
